import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { ValidationSchemaApi } from '../../models';

export const getValidationSchemas = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SPOT_QUOTE_V2}/validation-schemas/$GetAllLatestSchemas`,
  });
};

export const fetchValidationSchemas = async () => {
  const response: AxiosResponse<ValidationSchemaApi[]> = await getValidationSchemas();

  return response.data;
};
